// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3iBpy","title":"InfoRow_title__1QfWL"};